export const NavigationLinkClasses = { activeLink: 'navigationLink-active' };
